import { render } from "./HeroiconsOutlineCamera.vue?vue&type=template&id=557f536b"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCamera.vue"]])

export default __exports__